import {
  requestCdmTranslation,
  receiveCdmTranslation,
  errorCdmTranslation,
} from 'actions/cdmTranslationActions';
import { ErrorModel, CdmTranslationModel } from 'models';
import { createReducer } from './reducerUtils';

export type CdmTranslationState = Readonly<{
  cdmTranslation: CdmTranslationModel;
  error?: ErrorModel;
}>;

const initialState: CdmTranslationState = {
  cdmTranslation: {},
  error: undefined,
};

function requestCdmTranslationReducer(
  state: CdmTranslationState,
  action: ReturnType<typeof requestCdmTranslation>,
) {
  return {
    ...state,
    error: undefined,
  };
}

function receiveCdmTranslationReducer(
  state: CdmTranslationState,
  action: ReturnType<typeof receiveCdmTranslation>,
) {
  return {
    ...state,
    cdmTranslation: {
      ...state.cdmTranslation,
      ...action.payload.data,
    },
  };
}

function errorCdmTranslationReducer(
  state: CdmTranslationState,
  action: ReturnType<typeof errorCdmTranslation>,
) {
  return {
    ...state,
    error: action.payload.error,
  };
}

export default createReducer(initialState, {
  [requestCdmTranslation.type]: requestCdmTranslationReducer,
  [receiveCdmTranslation.type]: receiveCdmTranslationReducer,
  [errorCdmTranslation.type]: errorCdmTranslationReducer,
});
